var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5151e0c8492e5103c096af88a5293654"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    fill: "#f9007a"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M481.315,120.578H186.206c-16.641,0-30.184,13.5-30.184,30.093v210.658 c0,16.593,13.543,30.093,30.184,30.093h295.109c16.642,0,30.185-13.5,30.185-30.093V150.671 C511.5,134.078,497.957,120.578,481.315,120.578z M491.379,361.329c0,5.532-4.514,10.027-10.063,10.027H186.206 c-5.55,0-10.063-4.495-10.063-10.027V150.671c0-5.533,4.513-10.028,10.063-10.028h295.109c5.55,0,10.063,4.496,10.063,10.028 V361.329z M458.252,307.421c3.927,3.919,3.927,10.271,0,14.181c-1.966,1.966-4.543,2.942-7.116,2.942s-5.151-0.977-7.112-2.942 L381.58,259.35l-47.819,34.056l-47.819-34.056l-62.443,62.252c-1.961,1.966-4.539,2.942-7.112,2.942s-5.151-0.977-7.117-2.942 c-3.927-3.909-3.927-10.262,0-14.181l60.074-59.891l-58.803-41.883c-4.521-3.215-5.571-9.481-2.343-13.99 c3.233-4.508,9.512-5.554,14.038-2.33l111.525,79.427l111.525-79.427c4.521-3.224,10.801-2.178,14.038,2.33 c3.229,4.509,2.178,10.775-2.344,13.99l-58.802,41.883L458.252,307.421z M0.5,167.13h133.304v22.217H0.5V167.13z M89.37,233.783 h44.435V256H89.37H67.152H44.935v-22.217h22.217H89.37z M89.37,300.435h44.435v22.218H89.37V300.435z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.002547dfee614a82693e7882faa4c674.svg";
export { ForwardRef as ReactComponent };